import { Navigate } from "react-router";
import {
  GUEST_TOKEN_KEY,
  hasMemberSession,
} from "../common/authSession";

/**
 * Guest-only area: signed-in members are sent to the main app.
 * Optional requireGuestAuth: guest JWT required (post–guest-login steps).
 */
const GuestUserRoute = ({ children, requireGuestAuth = false }) => {
  if (hasMemberSession()) {
    return <Navigate to="/dashboard" replace />;
  }
  if (requireGuestAuth && !localStorage.getItem(GUEST_TOKEN_KEY)) {
    return <Navigate to="/guest-user/open-enrollment" replace />;
  }
  return <>{children}</>;
};

export default GuestUserRoute;
